import React from 'react';
import { RoutePermittedRole } from '@projectK/constants/AppEnums';
import ProductWizardPage from '../../modules/ProductWizardPage';
import PackageWidget from '../../modules/PackageWidget';

const Products = React.lazy(() => import('../../modules/student/Products'));

const ProductListing = React.lazy(() =>
  import('../../modules/student/Products/ProductListing'),
);
const ProgramDetail = React.lazy(() =>
  import('../../modules/student/Programs/ProgramDetail'),
);
const PackageDetail = React.lazy(() =>
  import('../../modules/student/Packages/PackageDetail'),
);
const ProductDetail = React.lazy(() =>
  import('../../modules/student/Products/ProductDetail'),
);
const OrdersHistory = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Orders'),
);
const ThridCalendar = React.lazy(() =>
  import('../../modules/thirdParty/calendar'),
);
const Cart = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Carts'),
);
const Checkout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout'),
);
const CardDetails = React.lazy(() =>
  import('../../modules/admin/CreditSystem/ManageCards'),
);
const CreditWallet = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditWallets'),
);
const CreditHistory = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditsHistory'),
);
const UserReports = React.lazy(() =>
  import('../../modules/admin/ReportManagement/UserReports'),
);
const StudentWaiver = React.lazy(() => import('../../modules/student/Waivers'));
const OrderConfirmation = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation'),
);
const TransactionHistory = React.lazy(() =>
  import('../../modules/student/TransactionHistory'),
);
const SettingsPage = React.lazy(() =>
  import('../../modules/student/SettingsPage'),
);
const PlayerReports = React.lazy(() =>
  import('../../modules/student/PlayerReports'),
);
const AccountPage = React.lazy(() =>
  import('../../modules/student/AccountInfo'),
);
const LockerPage = React.lazy(() =>
  import('../../../../../libs/modules/src/lib/account/MyProfile/LockerPage'),
);
const AutoLinks = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks'),
);
const AddToCart = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks/AddToCart'),
);
const AddToCartProduct = React.lazy(() =>
  import('../../modules/admin/Products/ProductLinks/AddToCartProduct'),
);
const Error403 = React.lazy(() => import('../../modules/errorPages/Error403'));
const AdminNote = React.lazy(() => import('../../modules/admin/AdminNote'));
export const studentPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.Student,
    path: '/student/product-listing',
    element: <ProductListing />,
  },
  {
    permittedRole: RoutePermittedRole.Student,
    path: '/student/products',
    element: <Products />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/product-details/:productId',
    element: <ProductDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/program-details/:programId',
    element: <ProgramDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/package-details/:packageId',
    element: <PackageDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/orders-history/',
    element: <OrdersHistory />,
  },
  {
    permittedRole: RoutePermittedRole.Admin,
    path: '/student/error-pages/error-403',
    element: <Error403 />,
  },

  {
    permittedRole: RoutePermittedRole.Student,
    path: '/student/waiver',
    element: <StudentWaiver />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/basic-calendar',
    element: <ThridCalendar />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/cart',
    element: <Cart />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/checkout',
    element: <Checkout />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/card-details',
    element: <CardDetails />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/credit-wallets',
    element: <CreditWallet />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/credit-history',
    element: <CreditHistory />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/user-reports',
    element: <UserReports />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/order/confirmation/:transId',
    element: <OrderConfirmation />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/my-account',
    element: <AccountPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/transaction-history',
    element: <TransactionHistory />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/settings',
    element: <SettingsPage />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/student/player-reports',
    element: <PlayerReports />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/my-profile',
    element: <LockerPage />,
  },
  {
    permittedRole: RoutePermittedRole.Student,
    path: '/widgets/products/:productSlug',
    element: <ProductWizardPage />,
  },
  {
    permittedRole: RoutePermittedRole.Student,
    path: '/widgets/packages/:packageSlug',
    element: <PackageWidget />,
  },
  {
    permittedRole: RoutePermittedRole.Student,
    path: '/purchasePackage/:purchaseId/:packageId',
    element: <AutoLinks />,
  },
  {
    permittedRole: RoutePermittedRole.Student,
    path: '/purchasePackage/addtocart/:purchaseId/:packageId',
    element: <AddToCart />,
  },
  {
    permittedRole: RoutePermittedRole.Student,
    path: '/product/addtocart/:purchaseId/:productId',
    element: <AddToCartProduct />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/notes',
    element: <AdminNote />,
  },
];
